import ConflictsHandler from './ConflictsHandler'

export default ConflictsHandler
